import React from 'react';
import { animated } from '@react-spring/web';

export function TransitionFadeOnAnimationValue({ motionValue, children, className = null, style = null }) {
  return (
    <animated.div style={{ opacity: motionValue, ...style }} className={className}>
      {children}
    </animated.div>
  );
}
